// extracted by mini-css-extract-plugin
export default {"version":"bv_gL"};